const colors = [
  'primary-10',
  'primary-30',
  'primary-50',
  'primary-70',
  'primary-90'
];

const NavigationStore = {
  /**
   * Whether the navigation popup is opened
   */
  isOpen: false,

  /**
   * Whether the search results dropdown within the navigation popup is opened
   */
  isSearchOpen: false,

  /**
   * The navigation popup background color
   */
  popupBgColor: colors[0],

  open() {
    this.isOpen = true;

    const nextColorIdx =
      (colors.indexOf(this.popupBgColor) + 1) % colors.length;

    this.popupBgColor = colors[nextColorIdx];
  },

  close() {
    this.isOpen = false;
  }
};

export default NavigationStore;
